import React from 'react';

const DeleteFobConnection  = ({ flagVisibleFob, dataConnectionFob, deleteFobHouse, deleteFobPillar, deleteFobWell, deleteFobCable, id }) => {

  return (
    <div style={{justifyContent: 'center'}}>
      <label style={{ color: '#dfab01', display: flagVisibleFob ? 'block' : 'none', fontSize: "18px" }}>Связи</label>

      {flagVisibleFob && dataConnectionFob && dataConnectionFob.houses && dataConnectionFob.houses.length > 0 && (
        <>
          {dataConnectionFob.listConnectionFob.some(item => item.houseId !== null) && (
            <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
              <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./house.png' alt='вектор' />
              <label style={{ color: '#dfab01', fontSize: "18px" }}>Дом</label>
              <hr className='horizontalLine2Modal'/>
              {dataConnectionFob.houses.map((item, index) => {
                const connectionItem = dataConnectionFob.listConnectionFob.find(connection => connection.houseId === item.id);
                return (
                  <div className='divBodyConnectModal' key={index}> 
                    <span style={{fontWeight: 'bold'}}>ID: {connectionItem ? connectionItem.houseId : 'N/A'}</span>
                    <br/>
                    <span style={{fontSize: "14px", color: "#202020"}}>
                      {item.street}, дом. {item.house} под.{connectionItem ? connectionItem.entrance : 'N/A'}
                    </span> 
                    <br/>
                    <button className='buttonIsEditDialog' style={{width: '80px'}} onClick={() => deleteFobHouse(id, connectionItem.houseId)}> Удалить</button>       
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}

      {flagVisibleFob && dataConnectionFob && dataConnectionFob.listConnectionFob && dataConnectionFob.listConnectionFob.length > 0 && (
        <>
          {dataConnectionFob.listConnectionFob.some(item => item.pillarId !== null) && (
            <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
              <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./pillar.png' alt='вектор' />
              <label style={{ color: '#dfab01', fontSize: "18px" }}>Опора</label>
              <hr className='horizontalLine2Modal'/>
              {dataConnectionFob.listConnectionFob.map((item, index) => (
                item.pillarId !== null && (
                  <div className='divBodyConnectModal' key={index}> 
                    <span style={{fontWeight: 'bold'}}>ID: {item.pillarId}</span>
                    <br/>
                    <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.pillarLatitude}, {item.pillarLongitude}</span>  
                    <br/>
                    <button className='buttonIsEditDialog' style={{width: '80px'}} onClick={() => deleteFobPillar(id, item.pillarId)}> Удалить</button>        
                  </div>
                )
              ))}
            </div>
          )}
        </>
      )}

      {flagVisibleFob && dataConnectionFob && dataConnectionFob.listConnectionFob && dataConnectionFob.listConnectionFob.length > 0 && (
        <>
          {dataConnectionFob.listConnectionFob.some(item => item.wellId !== null) && (
            <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
              <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./manhole.png' alt='вектор' />
              <label style={{ color: '#dfab01', fontSize: "18px" }}>Колодец</label>
              <hr className='horizontalLine2Modal'/>
              {dataConnectionFob.listConnectionFob.map((item, index) => (
                item.wellId !== null && (
                  <div className='divBodyConnectModal' key={index}> 
                    <span style={{fontWeight: 'bold'}}>ID: {item.wellId}</span>
                    <br/>
                    <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.wellLatitude}, {item.wellLongitude}</span>  
                    <br/>
                    <button className='buttonIsEditDialog' style={{width: '80px'}} onClick={() => deleteFobWell(id, item.wellId)}> Удалить</button>     
                  </div>
                )
              ))}
            </div>
          )}
        </>
      )}

      {flagVisibleFob && dataConnectionFob && dataConnectionFob.listConnectionFob && dataConnectionFob.listConnectionFob.length > 0 && (
        <>
          {dataConnectionFob.listConnectionFob.some(item => item.highwayLineId !== null) && (
            <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
              <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./cable.png' alt='вектор' />
              <label style={{ color: '#dfab01', fontSize: "18px" }}>Кабель</label>
              <hr className='horizontalLine2Modal'/>
              {dataConnectionFob.listConnectionFob.map((item, index) => (
                item.highwayLineId !== null && (
                  <div className='divBodyConnectModal' key={index}> 
                    <span style={{fontWeight: 'bold'}}>ID: {item.highwayLineId}</span>   
                    <br/>
                    <button className='buttonIsEditDialog' style={{width: '80px'}} onClick={() => deleteFobCable(id, item.highwayLineId)}> Удалить</button>      
                  </div>
                )
              ))}
            </div>
          )}
        </>
      )}

    </div>
  );
};

export default DeleteFobConnection;